/* ============================================================================
   PRESSROOM — Cutoff Countdown Bar davranışı
   <pressroom-countdown> web component (Dawn-style custom element).

   İŞ MANTIĞI (dtfnc.com kesim kuralı):
   - Kesim saati: cutoff_hour:cutoff_minute (default 12:00 PM) — timezone'da
     (default America/New_York). ZİYARETÇİNİN yerel saatinden BAĞIMSIZ: hedef
     hep o timezone'da hesaplanır (DST otomatik — Intl ile).
   - Açık günler: closed_days dışı (default Pazar=0 kapalı => Pzt-Cmt açık).
   - "Bir sonraki kesim" = now'dan büyük-eşit ilk hedef-saat, AÇIK bir günde.
     - Bugün açık VE now < bugün kesim => hedef bugün => "Ships today".
     - Aksi halde sonraki açık günü bul (kapalı günleri ATLA) => "Ships [Gün]".
   - Geri sayım 0'a inince otomatik bir sonraki kesime/güne kayar (canlı).

   DST-GÜVENLİK: Tarih aritmetiği yerel time'da (gün/saat ekleme),
   ardından `wallTimeToInstant` ile o "duvar saati"nin BELİRTİLEN timezone'daki
   gerçek UTC anına çevrilir (Intl.DateTimeFormat ile offset bulunur). Böylece
   DST geçişlerinde (Mart/Kasım) doğru kalır.

   a11y: görsel sayaç aria-hidden (her saniye okutma YOK). Yanında bir kez
   statik erişilebilir özet sunulur. document.hidden iken interval durur.
   reduced-motion: sayaç yine sayar (bilgi); dekoratif animasyon zaten yok.
   ============================================================================ */
(function () {
  'use strict';

  var WEEKDAYS = [
    'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'
  ];

  /**
   * Verilen UTC instant'ın belirtilen timezone'daki duvar-saati parçalarını
   * döndürür (yıl/ay/gün/saat/dakika/saniye + haftanın günü 0-6).
   */
  function getTzParts(instant, timeZone) {
    var dtf = new Intl.DateTimeFormat('en-US', {
      timeZone: timeZone,
      year: 'numeric', month: 'numeric', day: 'numeric',
      hour: 'numeric', minute: 'numeric', second: 'numeric',
      hour12: false, weekday: 'short'
    });
    var parts = dtf.formatToParts(instant);
    var map = {};
    for (var i = 0; i < parts.length; i++) {
      if (parts[i].type !== 'literal') map[parts[i].type] = parts[i].value;
    }
    var hour = parseInt(map.hour, 10);
    if (hour === 24) hour = 0; // bazı motorlar 24:00 döndürebilir
    var wdShort = map.weekday; // "Mon" vb.
    var dayIndex = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(wdShort);
    return {
      year: parseInt(map.year, 10),
      month: parseInt(map.month, 10),
      day: parseInt(map.day, 10),
      hour: hour,
      minute: parseInt(map.minute, 10),
      second: parseInt(map.second, 10),
      weekday: dayIndex
    };
  }

  /**
   * Belirtilen timezone'daki bir "duvar saati"ni (Y/M/D h:m:s) gerçek UTC
   * instant'ına (epoch ms) çevirir. DST-güvenli.
   *
   * Yöntem: hedef duvar saatini UTC varsay (guess). guess'in tz'deki gerçek
   * duvar saatini ölç; HEDEF duvar saati ile ölçülen arasındaki FARK kadar
   * guess'i kaydır. Bu farkı RESIDUAL olarak hesaplarız (offset'i iki kez
   * uygulamayız) — böylece bir düzeltme yeterlidir; DST sınırında ikinci
   * doğrulama yalnız KALAN fark varsa devreye girer.
   */
  function wallTimeToInstant(y, mo, d, h, mi, s, timeZone) {
    var desiredUtc = Date.UTC(y, mo - 1, d, h, mi, s); // hedef duvar saati referansı
    var guess = desiredUtc;
    // Bu instant tz'de hangi duvar saatine denk geliyor (UTC-epoch karşılığı)?
    var p = getTzParts(new Date(guess), timeZone);
    var producedUtc = Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second);
    // İstenen - üretilen = düzeltme miktarı (tz offset). guess'i bu kadar kaydır.
    var corrected = guess + (desiredUtc - producedUtc);
    // DST sınırında tek geçiş residual bırakabilir; KALAN farkı bir kez düzelt.
    var p2 = getTzParts(new Date(corrected), timeZone);
    var producedUtc2 = Date.UTC(p2.year, p2.month - 1, p2.day, p2.hour, p2.minute, p2.second);
    var residual = desiredUtc - producedUtc2;
    if (residual !== 0) corrected = corrected + residual;
    return corrected;
  }

  /**
   * now (Date) için bir sonraki kesim hedefini ve ship-day etiketini hesaplar.
   * closedDays: kapalı gün indeksleri dizisi (0=Pazar..6=Cumartesi).
   * @returns { targetMs, weekday (0-6), isToday }
   */
  function computeNextCutoff(now, cutoffHour, cutoffMinute, timeZone, closedDays) {
    var nowMs = now.getTime();
    // En fazla 14 gün ileri tara (kapalı gün dizilimleri için fazlasıyla yeterli).
    var todayParts = getTzParts(now, timeZone);
    for (var offset = 0; offset < 14; offset++) {
      // offset gün sonrasının tz takvim tarihini bul: bugünün tz tarihine
      // offset ekleyip yeniden tz'ye yansıt (DST/gün-uzunluğu güvenli).
      var probe = wallTimeToInstant(
        todayParts.year, todayParts.month, todayParts.day + offset,
        cutoffHour, cutoffMinute, 0, timeZone
      );
      var probeParts = getTzParts(new Date(probe), timeZone);
      // O gün kapalı mı?
      if (closedDays.indexOf(probeParts.weekday) !== -1) continue;
      // Hedef şu andan geride mi? (bugün için kesim geçmiş olabilir)
      if (probe <= nowMs) continue;
      return {
        targetMs: probe,
        weekday: probeParts.weekday,
        isToday: offset === 0
      };
    }
    // Fallback (teorik olarak ulaşılmaz): yarın aynı saat.
    var fb = wallTimeToInstant(
      todayParts.year, todayParts.month, todayParts.day + 1,
      cutoffHour, cutoffMinute, 0, timeZone
    );
    var fbParts = getTzParts(new Date(fb), timeZone);
    return { targetMs: fb, weekday: fbParts.weekday, isToday: false };
  }

  function pad2(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  function parseClosedDays(str) {
    if (!str) return [0];
    var out = [];
    var parts = String(str).split(',');
    for (var i = 0; i < parts.length; i++) {
      var v = parseInt(parts[i].trim(), 10);
      if (!isNaN(v) && v >= 0 && v <= 6 && out.indexOf(v) === -1) out.push(v);
    }
    return out.length ? out : [0];
  }

  class PressroomCountdown extends HTMLElement {
    constructor() {
      super();
      this._tick = this._tick.bind(this);
      this._onVisibility = this._onVisibility.bind(this);
      this._intervalId = null;
      this._target = null;
    }

    connectedCallback() {
      this.cutoffHour = parseInt(this.dataset.cutoffHour, 10);
      if (isNaN(this.cutoffHour)) this.cutoffHour = 12;
      this.cutoffMinute = parseInt(this.dataset.cutoffMinute, 10);
      if (isNaN(this.cutoffMinute)) this.cutoffMinute = 0;
      this.timeZone = this.dataset.timezone || 'America/New_York';
      this.closedDays = parseClosedDays(this.dataset.closedDays);
      this.prefixText = this.dataset.prefix || 'SHIPS';
      this.suffixText = this.dataset.suffix || 'IF ORDERED IN';

      this.elDay = this.querySelector('[data-cd-day]');
      this.elH = this.querySelector('[data-cd-h]');
      this.elM = this.querySelector('[data-cd-m]');
      this.elS = this.querySelector('[data-cd-s]');
      this.elSr = this.querySelector('[data-cd-sr]');

      // Geçersiz timezone'a karşı koruma: Intl patlarsa şerit gizlenmez ama
      // sayaç durur, statik özet kalır.
      try {
        new Intl.DateTimeFormat('en-US', { timeZone: this.timeZone });
      } catch (e) {
        this.timeZone = 'America/New_York';
      }

      this._recompute();
      this._tick();
      this._start();
      document.addEventListener('visibilitychange', this._onVisibility);
    }

    disconnectedCallback() {
      this._stop();
      document.removeEventListener('visibilitychange', this._onVisibility);
    }

    _start() {
      if (this._intervalId == null && !document.hidden) {
        this._intervalId = window.setInterval(this._tick, 1000);
      }
    }

    _stop() {
      if (this._intervalId != null) {
        window.clearInterval(this._intervalId);
        this._intervalId = null;
      }
    }

    _onVisibility() {
      if (document.hidden) {
        this._stop();
      } else {
        // Sekmeye dönünce anında güncelle + interval'i yeniden kur.
        this._recompute();
        this._tick();
        this._start();
      }
    }

    _recompute() {
      var now = new Date();
      this._target = computeNextCutoff(
        now, this.cutoffHour, this.cutoffMinute, this.timeZone, this.closedDays
      );
      this._renderDay();
    }

    _renderDay() {
      if (!this._target) return;
      var label;
      if (this._target.isToday) {
        label = 'today';
      } else {
        label = WEEKDAYS[this._target.weekday];
      }
      if (this.elDay) this.elDay.textContent = label;
      this._updateSr(null);
    }

    _updateSr(remainingMs) {
      if (!this.elSr) return;
      var dayLabel = this._target && this._target.isToday
        ? 'today'
        : (this._target ? WEEKDAYS[this._target.weekday] : '');
      var closedKey = this.closedDays.slice().sort(function (a, b) { return a - b; }).join(',');
      var openSummary =
        closedKey === '0' ? 'Monday to Saturday' :
        closedKey === '0,6' ? 'Monday to Friday' :
        'on open days';
      var hh = this.cutoffHour;
      var ampm = hh >= 12 ? 'PM' : 'AM';
      var hh12 = hh % 12; if (hh12 === 0) hh12 = 12;
      var cutoffStr = hh12 + (this.cutoffMinute ? ':' + pad2(this.cutoffMinute) : '') + ' ' + ampm + ' ET';
      this.elSr.textContent =
        'Order cutoff for shipping ' + dayLabel + ': ' + cutoffStr +
        ', ' + openSummary + '.';
    }

    _tick() {
      if (!this._target) return;
      var nowMs = Date.now();
      var diff = this._target.targetMs - nowMs;

      if (diff <= 0) {
        // Kesim geçti => bir sonraki hedefe kay (canlı, yenileme yok).
        this._recompute();
        nowMs = Date.now();
        diff = this._target.targetMs - nowMs;
        if (diff < 0) diff = 0;
      }

      var totalSec = Math.floor(diff / 1000);
      var hours = Math.floor(totalSec / 3600);
      var mins = Math.floor((totalSec % 3600) / 60);
      var secs = totalSec % 60;

      if (this.elH) this.elH.textContent = pad2(hours);
      if (this.elM) this.elM.textContent = pad2(mins);
      if (this.elS) this.elS.textContent = pad2(secs);
    }
  }

  if (!customElements.get('pressroom-countdown')) {
    customElements.define('pressroom-countdown', PressroomCountdown);
  }
})();
